import React, { useEffect, useState } from 'react'
import signName from './api'

export const SelectSign = ({onSignSelected}) => {
    const [signs, setSigns] = useState([])
    useEffect(()=>{
        setSigns(signName)
    }, [])

    return <>
        <div className='selSign'>Select Your Sign</div>        
        <div className='signW'>
            {signs.map((sign, index)=>{
                return <button key={index} onClick={()=>onSignSelected(sign)}>{sign}</button>
            })}
        </div>    
    </>
}